<script setup lang="ts">
import type { JobModel } from '@/types/jobModel';

defineOptions({
  name: 'JobListItem',
});

defineProps({
  job: {
    type: Object as PropType<JobModel>,
    required: true,
  },
});
</script>

<template>
  <NuxtLink :to="$mopI18n.localePath(`${$urls.CAREER_PAGE}/${job.getUrl()}`)" class="job-list-item" no-prefetch>
    <div class="job-list-item__title">
      {{ job.getTitle() }}
    </div>
    <div class="job-list-item__department">{{ job.getDepartment() }} {{ job.getLocation() }}</div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.job-list-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;

  text-transform: uppercase;
  padding: $space-24 $space-12;
  overflow: hidden;
}

.job-list-item__title {
  @include text-style(strong);
  font-size: 22px;
  line-height: 22px;
  letter-spacing: 0.22px;
}

.job-list-item__department {
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.3px;
}
</style>
